import React, { useEffect, useState } from 'react'
import { Dimensions, FlatList, ScrollView, StyleSheet, Text, TextInput, TouchableOpacity, View } from 'react-native'
import { AntDesign, Feather, Ionicons } from '@expo/vector-icons'
import { getConection } from '../appBar/context/HeaderContext'
import { fetchAuthSession } from 'aws-amplify/auth'
import { request_get_period, request_set_period_status } from '../../services/schedule.services'
import { Loader } from '../customUtils/Components/Loader'
import { STATUS_PERIOD, STATUS_KEYS, STATUS_MODERATION } from './constants/constants.stores'
import * as Progress from 'react-native-progress'
import { useNavigation } from '@react-navigation/native'
import { StackNavigationProp } from '@react-navigation/stack'
import { DotsNavigation } from '../navigation/stacks/NavigationStack'
import { useBottomSheet } from '../customUtils/context/BottomSheetContext'
import { SelectList } from 'react-native-dropdown-select-list'
import styles from './ModeratorRelevateDistributorsStyles'
import theme from '../../../theme'
import { colorFilled, colorUnfilled } from '../../../themeConstants'
import { getLanguage } from '../appBar/context/LocalizationContext'
import { DistributorCardStatustag } from './CreateSchedule'
import { Distributor, Period, Activity, Week, Day } from './models/CreateScheduleModel'

const { width } = Dimensions.get('window')

export const ModeratorRelevateDistributors = ({ route }) => {
    const { languageFile } = getLanguage()
    const id_period = route.params.id_period
    const { isConnected } = getConection()
    const navigation = useNavigation<StackNavigationProp<DotsNavigation>>()
    const [loading, setLoading] = useState(true)
    const [period, setPeriod] = useState<Period>({ _id: '', status: -1 })
    const [extraDistributors, setExtraDistributors] = useState<Distributor[]>([])

    let dropDownOptions = extraDistributors.filter((d) => d.status !== STATUS_MODERATION.APROBBED_AGGREGATED).map((d) => d)

    const [filteredDistributors, setFilteredDistributors] = useState<Distributor[]>([])
    const [originalLength, setOriginalLength] = useState(0)
    let title = period.schedule_period_name
    const [openPicker, setOpenPicker] = useState(false)

    useEffect(() => {
        fetchData(id_period)
    }, [])

    const fetchData = async (id_period: string) => {
        try {
            if (isConnected) {
                const session = await fetchAuthSession()
                const authToken = session.tokens?.accessToken?.toString() || ""
                const data = await request_get_period({ authToken, id_period })

                if (!data) {
                    setLoading(false)
                    return
                }
                if (data.period) {
                    let period = data.period
                    setFilteredDistributors(period.distributors)
                    setOriginalLength(period.distributors.length)
                    setExtraDistributors(data.distributors ?? [])
                    setPeriod(period)
                }

                setLoading(false)
            }
        } catch (error) {
            console.log('error', error)
            setLoading(false)
        }
    }

    if (loading) {
        return <Loader />
    }

    let aprobbedDistributors = filteredDistributors.filter((d) => d.status === STATUS_MODERATION.APPROBED).length
    let rejectedDistributors = filteredDistributors.filter((d) => d.status === STATUS_MODERATION.REJECTED).length
    let addedDistributors = filteredDistributors.filter((d) => d.status === STATUS_MODERATION.APROBBED_AGGREGATED).length
    let buttonEnabled = filteredDistributors.every((d) => d.status != STATUS_MODERATION.PENDING)
    let maxToSend = period.distributors_max ?? 9
    let validDistributors = filteredDistributors.filter(
        (d) => d.status === STATUS_MODERATION.APPROBED || d.status === STATUS_MODERATION.APROBBED_AGGREGATED,
    ).length

    let moderatedDistributors = (validDistributors * 100) / maxToSend

    const sendStep = async (distributors: Distributor[]) => {
        try {
            if (isConnected) {
                const session = await fetchAuthSession()
                const authToken = session.tokens?.accessToken?.toString() || ""
                let body = {}

                if (period.status == STATUS_PERIOD.PENDING_SET_DISTRIBUTORS || period.status == STATUS_PERIOD.PENDING_APPROBB_DISTRIBUTORS) {
                    body = {
                        key: STATUS_KEYS.KEY_DISTRIBUTOR,
                        period_id: id_period,
                        data: distributors,
                    }
                    console.log('body', body)
                    const data = await request_set_period_status({ authToken, body })
                    console.log('RTA', data)
                    if (!data) {
                        return
                    }
                    if (data.status == 1) {
                        navigation.goBack()
                    }
                }
            }
        } catch (error) {}
    }

    const validateDistributorStatus = (distributors: Distributor[], distributor: Distributor, status: number) => {
        if (status == 2 && rejectedDistributors === addedDistributors) {
            return
        }
        //
        if ((status == 1 || status == 2) && aprobbedDistributors + addedDistributors === maxToSend) {
            return
        }
        updateDistributorStatus(distributors, distributor, status)
    }

    const updateDistributorStatus = (distributors: Distributor[], distributor: Distributor, status: number) => {
        let newDistributors = distributors.map((d) => {
            if (d._id === distributor._id) {
                d.status = status
            }
            return d
        })
        setFilteredDistributors(newDistributors)
    }

    const onSelectItem = (item: Distributor) => {
        setOpenPicker(false)
        if (addedDistributors >= rejectedDistributors || aprobbedDistributors + addedDistributors === maxToSend) {
            return
        }
        let newDist = extraDistributors.find((d) => d._id === item._id)
        if (newDist) {
            newDist.status = STATUS_MODERATION.APROBBED_AGGREGATED
            let newDistributors = [...filteredDistributors, newDist]
            setExtraDistributors((i) =>
                i.map((d) => {
                    if (d._id === newDist._id) {
                        return newDist
                    }
                    return d
                }),
            )
            setFilteredDistributors(newDistributors)
        }
    }

    const deleteAggregated = (distributor: Distributor) => {
        let newDist = extraDistributors.find((d) => d._id === distributor._id)
        if (newDist) {
            newDist.status = STATUS_MODERATION.PENDING
            let newDistributors = filteredDistributors.filter((d) => d._id !== distributor._id)
            setExtraDistributors((i) =>
                i.map((d) => {
                    if (d._id === newDist._id) {
                        return newDist
                    }
                    return d
                }),
            )
            setFilteredDistributors(newDistributors)
        }
    }

    return (
        <View style={styles.container}>
            <ScrollView showsVerticalScrollIndicator={false}>
                <Text style={styles.title}>{title} 2024</Text>
                <View style={styles.spacer1}></View>
                <Progress.Bar
                    progress={moderatedDistributors / 100}
                    height={8}
                    width={width - 24}
                    style={styles.progressBar}
                    color={colorFilled}
                    unfilledColor={colorUnfilled}
                />

                <View style={[styles.containerRow, { justifyContent: 'space-between', marginRight: 12 }]}>
                    <View style={styles.containerRow}>
                        <Text style={styles.subtitle}>{'Aprobadas: '}</Text>
                        <Text style={styles.number}>{aprobbedDistributors}</Text>
                    </View>
                    <View style={styles.containerRow}>
                        <Text style={styles.subtitle}>{'Rechazadas: '}</Text>
                        <Text style={styles.number}>{rejectedDistributors}</Text>
                    </View>
                </View>

                {addedDistributors > 0 && (
                    <View style={styles.containerRow}>
                        <Text style={styles.subtitle}>{'Agregadas: '}</Text>
                        <Text style={styles.number}>{addedDistributors}</Text>
                    </View>
                )}

                {extraDistributors.length > 0 && (
                    <View>
                        <View style={styles.spacer1}></View>
                        <TouchableOpacity style={styles.input} onPress={() => setOpenPicker(!openPicker)}>
                            <Text style={styles.subtitle}>Agrega una distribuidora</Text>
                            <View style={styles.containerRow}>
                                {/*<Feather name={'search'} size={22} color={theme.colors.colorPrimary} />*/}
                                <Feather name={openPicker ? 'chevron-up' : 'chevron-down'} size={22} color={theme.colors.colorPrimary} />
                            </View>
                        </TouchableOpacity>
                        <View style={styles.spacer1}></View>
                        <View style={styles.spacer1}></View>
                        {openPicker && (
                            <View style={styles.inputDropdownMenuSubsection}>
                                {dropDownOptions.length > 0 && (
                                    <View>
                                        {dropDownOptions.map((distributor) => (
                                            <TouchableOpacity style={{ marginTop: 12 }} onPress={() => onSelectItem(distributor)}>
                                                <Text style={styles.titleDropdown}>{distributor.name}</Text>
                                                <Text style={styles.subtitle}>{distributor.address}</Text>
                                            </TouchableOpacity>
                                        ))}
                                    </View>
                                )}
                            </View>
                        )}
                    </View>
                )}

                <FlatList
                    data={filteredDistributors}
                    horizontal={false}
                    nestedScrollEnabled={true}
                    keyExtractor={(item, index) => index.toString()}
                    showsVerticalScrollIndicator={false}
                    renderItem={({ item: distributor }) => {
                        let newStatus = distributor.status

                        return (
                            <ModeratorDistributorsItem
                                data={distributor}
                                changeStatus={(status: number) => validateDistributorStatus(filteredDistributors, distributor, status)}
                                status={newStatus}
                                deleteAggregated={() => deleteAggregated(distributor)}
                            />
                        )
                    }}
                />
                <View style={styles.spacer3}></View>
                <View style={styles.buttonContainer}>
                    <TouchableOpacity
                        style={buttonEnabled ? styles.mainButton : styles.mainButtonDisabled}
                        onPress={() => sendStep(filteredDistributors)}
                        disabled={buttonEnabled ? false : true}
                    >
                        <Text style={buttonEnabled ? styles.mainButtonText : styles.mainButtonTextDisabled}>Siguiente</Text>
                    </TouchableOpacity>
                </View>
            </ScrollView>
        </View>
    )
}

export const ModeratorDistributorsItem = ({ data, changeStatus, status, deleteAggregated }) => {
    return (
        <View style={styles.containerRow}>
            {status != 2 ? (
                <View>
                    <TouchableOpacity style={styles.marginLeft} onPress={() => changeStatus(1)}>
                        <Ionicons name={status == 1 ? 'checkmark-circle' : 'checkmark-circle-outline'} size={26} color={theme.colors.colorApproved} />
                    </TouchableOpacity>
                    <View style={styles.spacer1}></View>
                    <TouchableOpacity style={styles.marginLeft} onPress={() => changeStatus(-1)}>
                        <Ionicons name={status == -1 ? 'close-circle' : 'close-circle-outline'} size={26} color={theme.colors.colorDisapproved} />
                    </TouchableOpacity>
                </View>
            ) : (
                <TouchableOpacity style={styles.marginLeft} onPress={() => deleteAggregated()}>
                    <Ionicons name={'trash'} size={28} color={theme.colors.error} />
                </TouchableOpacity>
            )}

            <View
                style={
                    status == 1
                        ? styles.cardContainerCheckSelected
                        : status == -1
                        ? styles.cardContainerCloseSelected
                        : styles.cardContainerUnselected
                }
            >
                <View style={styles.containerRow}>
                    <ModeratorDistributorsCard distributor={data} />
                </View>
            </View>
        </View>
    )
}
export const ModeratorDistributorsCard = ({ distributor }: { distributor: Distributor }) => {
    return (
        <View>
            <View style={styles.header}>
                <Feather name='truck' size={16} color={theme.colors.textPrimary} />
                <Text style={styles.headerText}>{distributor.name}</Text>
            </View>
            <View style={styles.infoContainer}>
                {distributor.code && <Text style={styles.storecode}>{distributor.code}</Text>}
                {distributor.distance && (
                    <View style={styles.containerData}>
                        <Text style={styles.separator}> | </Text>
                        <Feather name='map-pin' size={14} color={theme.colors.textSecondary} />
                        <Text style={styles.infoText}>{distributor.distance}</Text>
                    </View>
                )}
            </View>
            {distributor.address && <Text style={styles.addressText}>{distributor.address}</Text>}
            <View style={styles.spacer1}></View>
            <DistributorCardStatustag status={distributor.status} />
        </View>
    )
}
